/**
 * Lógica pura de inventario (CC-6: NUNCA usar macros lingui aquí).
 *
 * Las cantidades y costos se almacenan en ENTEROS (unidades menores) para
 * evitar el redondeo de floats. El factor de escala es 1000 (milésimas), igual
 * que el patrón de unidades menores de cashsync.
 */

/** Factor de escala: 1 unidad de UI = 1000 unidades menores almacenadas. */
export const QTY_SCALE = 1000;

/** Convierte una cantidad de UI (p. ej. 12.5) a unidades menores enteras. */
export function toMinorQty(display: number): number {
  return Math.round(display * QTY_SCALE);
}

/** Convierte unidades menores almacenadas a cantidad de UI. */
export function fromMinorQty(minor: number): number {
  return minor / QTY_SCALE;
}

/**
 * Formatea unidades menores como texto legible. Sin macros lingui: el caller
 * pasa el separador ya resuelto si necesita localización.
 */
export function formatQty(minor: number, fractionDigits = 2): string {
  return fromMinorQty(minor)
    .toFixed(fractionDigits)
    .replace(/\.?0+$/, "");
}

/**
 * Parsea texto de entrada del usuario a unidades menores. Acepta coma o punto
 * como separador decimal. Devuelve null si no es un número válido.
 */
export function parseQtyInput(raw: string): number | null {
  const normalized = raw.trim().replace(",", ".");
  if (normalized === "") {
    return null;
  }
  const value = Number(normalized);
  if (!Number.isFinite(value)) {
    return null;
  }
  return toMinorQty(value);
}

/**
 * Calcula el nuevo on-hand tras un ajuste de inventario. El ajuste es la
 * cantidad CONTADA (objetivo); devuelve el delta (move) y el nuevo on-hand.
 */
export function computeAdjustment(
  currentOnHand: number,
  countedOnHand: number,
): { delta: number; newOnHand: number } {
  return { delta: countedOnHand - currentOnHand, newOnHand: countedOnHand };
}

/** Aplica un move (delta) al on-hand actual derivando el nuevo saldo. */
export function applyMove(currentOnHand: number, delta: number): number {
  return currentOnHand + delta;
}
